<div class="profile-edit-email">

    @for (emailControlsGroup of emailControlsGroups; track emailControlsGroup) {
    <div class="profile-edit-email-item" [class.profile-edit-email-item--login]="emailControlsGroup.isForLogin">

        <div class="profile-edit-email-item-header">

            <div class="profile-edit-email-item-header-title">
                {{ 'EMAILS_EDIT_FORM.TITLES.EMAIL' | translate }} {{ $index + 1 }}
            </div>

            @if (emailControlsGroup.isForLogin) {
            <div class="profile-edit-email-item-header-label"
                [title]="'EMAILS_EDIT_FORM.TITLES.LOGIN_EMAIL' | translate">

                <div class="profile-edit-email-item-header-label-text">
                    {{ 'EMAILS_EDIT_FORM.TITLES.LOGIN_EMAIL' | translate }}
                </div>

            </div>
            } @else {
            <rpc-button class="profile-edit-email-item-header-btn" [color]="'warn'"
                [text]="'EMAILS_EDIT_FORM.TITLES.DELETE'" [iconName]="'delete-bin'" (clicked)="removeEmail($index)">
            </rpc-button>
            }

        </div>

        <div class="profile-edit-email-item-body">

            <rpc-select class="profile-edit-email-item-body-select" [color]="'accent'"
                [label]="'EMAILS_EDIT_FORM.TITLES.TYPE'" [controlOptions]="emailControlsGroup.selectOptions"
                [appearance]="'fill'" [disabled]="emailControlsGroup.isForLogin">
            </rpc-select>

            <rpc-input class="profile-edit-email-item-body-input" [label]="'EMAILS_EDIT_FORM.TITLES.EMAIL_ADDRESS'"
                [type]="'email'" [appearance]="'fill'" [options]="emailControlsGroup.inputOptions"
                [disabled]="emailControlsGroup.isForLogin">
            </rpc-input>

            @if (emailControlsGroup.isForLogin) {
            <div class="profile-edit-email-item-body-hint">
                {{ 'EMAILS_EDIT_FORM.TITLES.LOGIN_DISABLE_EXPLANATION' | translate }}
            </div>
            } @else {
            <div class="profile-edit-email-item-toggle-wrap">

                <rpc-slide-toggle class="profile-edit-email-item-toggle"
                    [form]="emailControlsGroup.inputOptions.formGroup" [controlName]="'isCarbonCopy'"
                    [firstText]="'EMAILS_EDIT_FORM.TITLES.ADD_CC'" [hint]="'EMAILS_EDIT_FORM.TITLES.ADD_CC_EPLANATION'"
                    [checked]="emailControlsGroup.isCarbonCopy">
                </rpc-slide-toggle>

            </div>
            }

        </div>

    </div>
    }

    <div class="profile-edit-email-add-wrap">

        <rpc-button [color]="'accent'" [iconName]="'add-new'" [text]="'EMAILS_EDIT_FORM.TITLES.ADD_NEW'"
            (clicked)="addEmail()">
        </rpc-button>

    </div>

</div>